import { Routes, RouterModule } from '@angular/router';
import {AuthGuard, AnonymousGuard, CanDeactivateGuard, CampaignGuard} from './_guards';
import { LoginComponent } from './login';
import { RegisterComponent, RegisterVerifyComponent } from './register';
import { VisitorsComponent } from './visitors';
import { MerchantProfilesComponent, MerchantProfilesNewComponent, MerchantProfilesEditComponent } from './merchant-profiles';
import { SubscriptionComponent, SubscriptionEditComponent } from "./subscription";
import { PaymentSourceComponent, CreditCardEditComponent, CreditCardNewComponent,
  BankAccountNewComponent } from "./payment-source";
import { AddressComponent, AddressEditComponent, AddressNewComponent } from "./address";
import { PhoneComponent, PhoneSearchComponent, PhoneNewComponent, PhoneEditComponent } from "./phone";
import { CRMComponent, CRMEditComponent, CRMNewComponent } from "./crm";
import {CampaignCategoryComponent, ProductCategoryComponent, WidgetCategoryComponent} from './category';
import {
  CampaignComponent, CampaignNewComponent, CampaignEditComponent, CampaignEmailComponent,
  CampaignPhoneComponent, CampaignVerifyComponent, CampaignFunnelsComponent,
  CampaignStylesComponent, CampaignTestComponent, CampaignProductsComponent, CampaignMarketplaceComponent,
  CampaignCallCenterComponent, CampaignCampaignsComponent, CampaignSummaryComponent
} from './campaign';
import { ProductInfoSectionComponent, ProductInfoSectionNewComponent,
  ProductInfoSectionEditComponent } from './product';
import { CampaignProductComponent } from './campaign-product';
import { OrderManagementPortalComponent } from './order-management-portal';
import { ImageComponent, ImageUploadComponent } from './image';
import { IconComponent } from './icon';
import { VisualFunnelComponent, FunnelNewComponent, FunnelEditComponent, ProductFunnelComponent,
  FunnelComponent} from "./funnel";
import { FunnelStepEditComponent, FunnelStepNewComponent } from './funnel-step';
import { FunnelInputEditComponent, FunnelInputNewComponent } from './funnel-input';
import { FunnelActionEditComponent, FunnelActionNewComponent } from './funnel-action';
import { StyleComponent, StyleNewComponent, StyleEditComponent } from './style';
import { AudioFileComponent, AudioFileUploadComponent } from "./audio-file";
import { EmailTemplateComponent, EmailTemplateNewComponent, EmailTemplateEditComponent } from './email-template';
import { AutoResponderComponent, AutoResponderNewComponent, AutoResponderEditComponent } from './autoresponder';
import { RegisterSuccessComponent } from './register-success';
import {
  PasswordChangeComponent, PasswordResetComponent, PasswordResetSuccessComponent,
  PasswordResetConfirmComponent, ResendActivationEmailComponent
} from './password-reset';
import {
  FaqsComponent,
  FaqTopicNewComponent,
  FaqTopicEditComponent,
  FaqNewComponent,
  FaqEditComponent
} from './faq';
import { TroubleshooterComponent } from "./troubleshooter";
import { CustomerPortalEditComponent} from "./customer-portal";
import { SessionDetailComponent } from './session';
import { LifelineComponent } from "./lifeline";
import { SurveyComponent } from "./survey";
import {AccountComponent, AccountEmailBlacklistComponent, AccountSearchKeywordsComponent} from './account';
import { FunnelStepGroupComponent } from './funnel-step-group';
import { CampaignTrackingComponent } from "./campaign-tracking";
import { VoiceFunnelComponent } from "./voice-funnel";
import {
  FaqReportsComponent,
  PathPerformanceReportComponent,
  PerformanceReportComponent,
  RefundReportComponent,
  ReportsComponent,
  ChargebackReportComponent,
  SessionSummaryReportComponent,
  MarketplaceReportComponent,
  RetentionReportComponent, PaymentUpdaterReportComponent
} from './legacy-reports';
import { WidgetComponent } from './widget';
import { SalesPhraseComponent } from "./sales-phrase";
import { CallCenterActionComponent } from "./call-center-action";
import { HybridFunnelComponent } from './hybrid-funnel';
import { HybridCampaignComponent, HybridCampaignNewComponent } from './hybrid-campaign';
import { EmailLogsContainerComponent, PhoneLogsContainerComponent, SmsLogsContainerComponent } from "./logs";
import { DesignTemplateComponent, DesignTemplateEditFormComponent } from './design-template';
import {
  PlanComponent,
  PlanNewComponent,
  PlanEditComponent,
  ResolvePlanComponent,
  ResolvePlanNewComponent,
  ResolvePlanEditComponent,
} from "./plan";
import { InvoiceItemComponent } from './invoice-item';
import { InvoiceComponent, InvoiceDetailComponent } from './invoice';
import { CRMCampaignComponent } from './crm-campaign';
import { UserComponent, UserInviteAcceptComponent, UserApiKeyComponent, UserProxyKeyComponent } from "./user";
import { ProfilerEnableComponent, ProfilerDisableComponent } from './profiler';
import {PersonalInfoComponent} from "./personal-info";
import {ExchangeableProductsSetComponent, ExchangeableProductsSetNewComponent,
  ExchangeableProductsSetEditComponent} from './exchangeable-products-set';
import {RelatedProductSetCategoryEditComponent, RelatedProductSetCategoryNewComponent,
  RelatedProductSetCategoryComponent} from './related-product-set-category';
import {RelatedProductSetEditComponent, RelatedProductSetNewComponent} from './related-product-set';
import {ReasonCategoryComponent, ReasonCategoryNewComponent, ReasonCategoryEditComponent} from './reason-category';
import {FolderEditComponent, FolderNewComponent} from './folder';
import { DashboardComponent } from './dashboard/dashboard.component';
import { GatewayDashboardComponent } from './dashboard/gateway-dashboard';
import { DashboardSections } from './_models';
import {DevEnvComponent, DevEnvNewComponent} from './dev-env';
import {
  RefundReportV2Component,
  SubscriptionRetentionReportV2Component,
  SubscriptionRetentionReportV3Component,
  ReturnRetentionReportV2Component,
  NewOrderRetentionReportV2Component,
  OrderRetentionReportV3Component,
  ReturnRetentionReportV3Component,
  PaymentUpdaterReportV2Component,
  ChargebackReportV2Component,
  SPTouchedChargebackReportV2Component,
  ChatbotReportV2Component,
  GatewayTransactionReportV2Component,
  GatewayPerformanceReportV3Component,
  OrderOptionsReportComponent,
  TrafficSourceReportComponent,
  CustomerSupportReportV3Component,
  CustomerJourneyReportV3Component,
  ResolveReportV3Component,
  SingleStepReportComponent,
} from './reports';
import { TicketSystemComponent, TicketSystemNewComponent, TicketSystemEditComponent } from './ticket-system';
import { ShippingSystemComponent, ShippingSystemNewComponent, ShippingSystemEditComponent } from './shipping-system';
import { SSOCompleteComponent } from './sso-complete/sso-complete.component';
import { SsoFlagGuard } from './sso-flag.guard';
import {AudienceComponent, AudienceEditComponent, AudienceNewComponent} from './audience';
import {PathComponent, PathEditComponent, PathNewComponent} from './path-builder';
import {
  EmailIntegrationForwardingEditComponent,
  EmailIntegrationForwardingNewComponent,
  EmailIntegrationSelectComponent, GmailAuthCallbackComponent
} from './email-integration';
import {MouseflowToggleComponent} from './mouseflow';
import {
  CampaignBrandingComponent,
  CampaignGeneralComponent,
  CampaignDomainsComponent,
  CampaignCallCenterSettingsComponent,
  CampaignPhoneSetupComponent,
  CampaignEmailSetupComponent,
  CampaignAutorespondersComponent,
  CampaignCustomerLoginSettingsComponent,
  CampaignPolicyComponent,
  CampaignDeploymentPageComponent,
  CampaignCustomerPortalSettingsComponent,
  CampaignMarketplaceSettingsComponent,
  CampaignCRMsComponent
} from './campaign-v2';
import {SmartlinkPreviewComponent} from './smartlink-preview';

const appRoutes: Routes = [
  { path: '', component: DashboardComponent, canActivate: [AuthGuard, SsoFlagGuard], data: {title: 'Dashboard', hideBackButton: true} },
  // Product dashboards: dashboardSections are the sections shown, as tabs when more than one.
  { path: 'dashboard/retention', component: DashboardComponent, canActivate: [AuthGuard],
    data: {title: 'Dashboard', hideBackButton: true, dashboardSections: [DashboardSections.Subscription, DashboardSections.Order]} },
  { path: 'dashboard/returns', component: DashboardComponent, canActivate: [AuthGuard],
    data: {title: 'Dashboard', hideBackButton: true, adminOnly: true, dashboardSections: [DashboardSections.Return]} },
  { path: 'dashboard/resolve', component: DashboardComponent, canActivate: [AuthGuard],
    data: {title: 'Resolve Dashboard', hideBackButton: true, adminOnly: true, dashboardSections: [DashboardSections.Resolve]} },
  { path: 'user',
    children: [
      { path: 'login', component: LoginComponent, canActivate: [AnonymousGuard] },
      { path: 'resend/activation', component: ResendActivationEmailComponent, canActivate: [AnonymousGuard] },
      { path: 'register', component: RegisterComponent, canActivate: [AnonymousGuard], canDeactivate: [CanDeactivateGuard] },
      { path: 'register-success', component: RegisterSuccessComponent },
      { path: 'verify', component: RegisterVerifyComponent },
      { path: 'subscribe', component: SubscriptionComponent, canActivate: [AuthGuard], data: {adminOnly: true} },
      { path: 'subscribe/edit', component: SubscriptionEditComponent, canActivate: [AuthGuard], data: {adminOnly: true} }
    ]
  },
  { path: 'payment', data: {title: 'Payment'},
      children: [
        { path: 'sources', component: PaymentSourceComponent, canActivate: [AuthGuard] },
        { path: 'card', canActivate: [AuthGuard],
          children: [
            { path: '', component: PaymentSourceComponent, canActivate: [AuthGuard] },
            { path: 'edit/:id', component: CreditCardEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
            { path: 'new', component: CreditCardNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] }
          ]
        },
        { path: 'bank-account', canActivate: [AuthGuard],
          children: [
            { path: '', component: PaymentSourceComponent, canActivate: [AuthGuard] },
            { path: 'new', component: BankAccountNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] }
          ]
        },
      ]
  },
  { path: 'addresses', component: AddressComponent, canActivate: [AuthGuard], data: {title: 'Addresses'} },
  { path: 'address', canActivate: [AuthGuard],
    children: [
      { path: 'edit/:id', component: AddressEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
      { path: 'new', component: AddressNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] }
    ]
  },
  { path: 'visitors', component: VisitorsComponent, canActivate: [AuthGuard], data: {title: 'Visitors'} },
  { path: 'phone', canActivate: [AuthGuard], data: {title: 'Phone'},
    children: [
      { path: '', component: PhoneComponent, canActivate: [AuthGuard] },
      { path: 'search', component: PhoneSearchComponent, canActivate: [AuthGuard] },
      { path: 'new/:type', component: PhoneNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: PhoneEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'crms', component: CRMComponent, canActivate: [AuthGuard], data: {title: 'CRM'} },
  { path: 'crm', canActivate: [AuthGuard],
    children: [
      { path: 'new', component: CRMNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: CRMEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'campaigns', component: CampaignComponent, canActivate: [AuthGuard], data: {title: "Brands"} },
  { path: 'order-management-portal', component: OrderManagementPortalComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard], data: {title: 'Order Management Portal'} },
  { path: 'campaign', canActivate: [AuthGuard], data: {breadcrumb: 'Brand', title: 'Brand Settings'},
    children: [
      { path: '', component: CampaignComponent, canActivate: [AuthGuard] },
      { path: 'categories', component: CampaignCategoryComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Categories'} },
      { path: 'edit/:id', component: CampaignEditComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Edit'}, canDeactivate: [CanDeactivateGuard] },
      { path: 'phone', data: {breadcrumb: ''},
        children: [
          { path: ':id', component: CampaignPhoneComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Phone Setup'}},
        ]
      },
      { path: 'email/:id', component: CampaignEmailComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Edit Email'}, canDeactivate: [CanDeactivateGuard] },
      { path: 'call-center/:id', component: CampaignCallCenterComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Edit Call Center'}, canDeactivate: [CanDeactivateGuard] },
      { path: 'paths/:id', component: CampaignFunnelsComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Edit Paths'}, canDeactivate: [CanDeactivateGuard] },
      { path: 'products/:id', component: CampaignProductsComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Edit CRM Campaigns'}, canDeactivate: [CanDeactivateGuard] },
      { path: 'marketplace/:id', component: CampaignMarketplaceComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Edit Marketplace'}, canDeactivate: [CanDeactivateGuard] },
      { path: 'styles/:id', component: CampaignStylesComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Edit Themes'}, canDeactivate: [CanDeactivateGuard] },
      { path: 'campaigns/:id', component: CampaignCampaignsComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Edit Brands'}, canDeactivate: [CanDeactivateGuard] },
      { path: 'test/:id', component: CampaignTestComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Edit Test'}, canDeactivate: [CanDeactivateGuard] },
      { path: 'summary/:id', component: CampaignSummaryComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Summary'}, canDeactivate: [CanDeactivateGuard] },
      { path: 'new', component: CampaignNewComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Add new'}, canDeactivate: [CanDeactivateGuard] },
      { path: 'verify', component: CampaignVerifyComponent, data: {breadcrumb: 'Verify'} },
      { path: 'general', component: CampaignGeneralComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'branding', component: CampaignBrandingComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'domains', component: CampaignDomainsComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'call-center', component: CampaignCallCenterSettingsComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'phone-setup', component: CampaignPhoneSetupComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'email-setup', component: CampaignEmailSetupComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'autoresponders', component: CampaignAutorespondersComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'login-settings', component: CampaignCustomerLoginSettingsComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'policy', component: CampaignPolicyComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'deployment', component: CampaignDeploymentPageComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'customer-portal-settings', component: CampaignCustomerPortalSettingsComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'marketplace-settings', component: CampaignMarketplaceSettingsComponent, canActivate: [AuthGuard, CampaignGuard] },
      { path: 'crm-campaigns', component: CampaignCRMsComponent, canActivate: [AuthGuard, CampaignGuard] },
    ]
  },
  { path: 'hybrid-campaigns', component: HybridCampaignComponent, canActivate: [AuthGuard], data: {title: "Hybrid Brands"} },
  { path: 'hybrid-campaign', canActivate: [AuthGuard], data: {breadcrumb: 'Hybrid Brand'},
    children: [
      { path: '', component: HybridCampaignComponent, canActivate: [AuthGuard] },
      { path: 'new', component: HybridCampaignNewComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Add new'}, canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'product', canActivate: [AuthGuard], data: {title: 'Products'},
    children: [
      { path: 'categories', component: ProductCategoryComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Categories'} },
      { path: 'sections', component: ProductInfoSectionComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Existing sections'} },
      { path: 'section', canActivate: [AuthGuard], data: {breadcrumb: 'Section'},
        children: [
          { path: 'new', component: ProductInfoSectionNewComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Add'}, canDeactivate: [CanDeactivateGuard] },
          { path: 'edit/:id', component: ProductInfoSectionEditComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Edit'}, canDeactivate: [CanDeactivateGuard] },
        ]
      },
    ]
  },
  { path: 'campaign-products', component: CampaignProductComponent, canActivate: [AuthGuard], data: {breadcrumb: "Existing products", title: "Products"} },
  { path: 'crm-campaigns', component: CRMCampaignComponent, canActivate: [AuthGuard], data: {title: "Products", breadcrumb: 'CRM Campaigns'} },
  { path: 'images', component: ImageComponent, canActivate: [AuthGuard], data: {title: 'Images'} },
  { path: 'images/upload', component: ImageUploadComponent, canActivate: [AuthGuard] },
  { path: 'icons', component: IconComponent, canActivate: [AuthGuard], data: {title: 'Icons'} },
  { path: 'smartlink-preview', component: SmartlinkPreviewComponent, canActivate: [AuthGuard] },
  { path: 'content', component: WidgetComponent, canActivate: [AuthGuard], data: {title: 'Content'} },
  { path: 'styles', component: StyleComponent, canActivate: [AuthGuard], data: {title: 'Styles'} },
  { path: 'style', canActivate: [AuthGuard],
    children: [
      { path: 'new', component: StyleNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: StyleEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'paths', component: FunnelComponent, canActivate: [AuthGuard, CampaignGuard], data: {title: 'Paths'} },
  { path: 'support-paths', component: VisualFunnelComponent, canActivate: [AuthGuard, CampaignGuard], data: {title: 'Support Paths'} },
  { path: 'subpaths', component: ProductFunnelComponent, canActivate: [AuthGuard], data: {title: 'Subpaths'} },
  { path: 'path', canActivate: [AuthGuard],
    children: [
      { path: 'new', component: FunnelNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: FunnelEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
      { path: ':funnel_id', canActivate: [AuthGuard],
        children: [
          { path: 'step', canActivate: [AuthGuard],
            children: [
              { path: 'new', component: FunnelStepNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
              { path: 'edit/:id', component: FunnelStepEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
              { path: ':step_id/input', canActivate: [AuthGuard],
                children: [
                  { path: 'new', component: FunnelInputNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
                  { path: 'edit/:id', component: FunnelInputEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
                ]
              },
            ]
          },
          {path: 'input/:input_id/action', canActivate: [AuthGuard],
            children: [
              { path: 'new', component: FunnelActionNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
              { path: 'edit/:id', component: FunnelActionEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
            ]
          },
        ]
      },
    ]
  },
  { path: 'audio-files', component: AudioFileComponent, canActivate: [AuthGuard], data: {title: 'Audio Files'} },
  { path: 'audio/upload', component: AudioFileUploadComponent, canActivate: [AuthGuard] },
  { path: 'email-templates', component: EmailTemplateComponent, canActivate: [AuthGuard], data: {title: 'Email Templates'} },
  { path: 'email-template', canActivate: [AuthGuard],
    children: [
      { path: 'new', component: EmailTemplateNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: EmailTemplateEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'autoresponders', component: AutoResponderComponent, canActivate: [AuthGuard], data: {title: 'Autoresponders'} },
  { path: 'autoresponder', canActivate: [AuthGuard],
    children: [
      { path: 'new', component: AutoResponderNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: AutoResponderEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'password', canActivate: [AnonymousGuard],
    children: [
      { path: 'reset', canActivate: [AnonymousGuard],
        children: [
          { path: '', component: PasswordResetComponent, canActivate: [AnonymousGuard] },
          { path: 'success', component: PasswordResetSuccessComponent },
          { path: 'confirm', component: PasswordResetConfirmComponent },
        ]
      }
    ]
  },
  { path: 'password-change', component: PasswordChangeComponent, canActivate: [AuthGuard], data: {title: 'Password Change'} },
  { path: 'faqs', component: FaqsComponent, canActivate: [AuthGuard], data: {title: 'FAQs'} },
  { path: 'faq-topic', canActivate: [AuthGuard],
    children: [
      { path: 'new', component: FaqTopicNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: FaqTopicEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'faq', canActivate: [AuthGuard],
    children: [
      { path: 'new', component: FaqNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: FaqEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'troubleshooters', component: TroubleshooterComponent, canActivate: [AuthGuard], data: {title: 'Troubleshooters'} },
  { path: 'lifelines', component: LifelineComponent, canActivate: [AuthGuard], data: {adminOnly: true, title: 'Lifelines'} },
  { path: 'surveys', component: SurveyComponent, canActivate: [AuthGuard], data: {title: 'Surveys'} },
  { path: 'phone-paths', component: VoiceFunnelComponent, canActivate: [AuthGuard, CampaignGuard], data: {title: 'Phone Paths'} },
  { path: 'hybrid-paths', component: HybridFunnelComponent, canActivate: [AuthGuard], data: {title: 'Hybrid Paths'} },
  { path: 'session/:id', component: SessionDetailComponent, canActivate: [AuthGuard] },
  { path: 'accounts', component: AccountComponent, canActivate: [AuthGuard], data: {title: 'Accounts'} },
  { path: 'users', component: UserComponent, canActivate: [AuthGuard], data: {title: 'Users'} },
  { path: 'api-keys', component: UserApiKeyComponent, canActivate: [AuthGuard], data: {title: 'API Keys'} },
  { path: 'proxy-keys', component: UserProxyKeyComponent, canActivate: [AuthGuard], data: {adminOnly: true} },
  { path: 'invite-accept', component: UserInviteAcceptComponent, canActivate: [AnonymousGuard] },
  { path: 'email-blacklist/:id', component: AccountEmailBlacklistComponent, canActivate: [AuthGuard] },
  { path: 'path-step-groups', component: FunnelStepGroupComponent, canActivate: [AuthGuard], data: {title: 'Path Step Groups'} },
  { path: 'campaign/:campaign/tracking', component: CampaignTrackingComponent, canActivate: [AuthGuard] },
  { path: 'sales-phrases', component: SalesPhraseComponent, canActivate: [AuthGuard], data: {title: 'Sales Phrases'} },
  { path: 'call-center-actions', component: CallCenterActionComponent, canActivate: [AuthGuard], data: {title: 'Call Center Actions'} },
  { path: 'reports', component: ReportsComponent, canActivate: [AuthGuard], data: {title: "Reports"} },
  { path: 'faq-reports', component: FaqReportsComponent, canActivate: [AuthGuard], data: {breadcrumb: "Faq Reports"} },
  { path: 'report/:id', component: ReportsComponent, canActivate: [AuthGuard], data: {breadcrumb: "Reports"} },
  { path: 'phone-logs', component: PhoneLogsContainerComponent, canActivate: [AuthGuard],
    data: {adminOnly: true, breadcrumb: "Phone logs"} },
  { path: 'sms-logs', component: SmsLogsContainerComponent, canActivate: [AuthGuard],
    data: {adminOnly: true, breadcrumb: "SMS logs"} },
  { path: 'email-logs', component: EmailLogsContainerComponent, canActivate: [AuthGuard],
    data: {adminOnly: true, breadcrumb: "Email logs"} },
  { path: 'template', canActivate: [AuthGuard], data: {title: 'Templates'},
    children: [
      {path: '', component: DesignTemplateComponent, canActivate: [AuthGuard]},
      {path: 'new', component: DesignTemplateEditFormComponent, canActivate: [AuthGuard]},
      {path: 'edit/:id', component: DesignTemplateEditFormComponent, canActivate: [AuthGuard]},
      { path: 'categories', component: WidgetCategoryComponent, canActivate: [AuthGuard], data: {breadcrumb: 'Categories'} },
    ]
  },
  { path: 'plans', component: PlanComponent, canActivate: [AuthGuard], data: {adminOnly: true, title: 'Plans'} },
  { path: 'plan', canActivate: [AuthGuard], data: {adminOnly: true},
    children: [
      { path: 'new', component: PlanNewComponent, canActivate: [AuthGuard], data: {adminOnly: true},
        canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: PlanEditComponent, canActivate: [AuthGuard], data: {adminOnly: true},
        canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'resolve-plans', component: ResolvePlanComponent, canActivate: [AuthGuard], data: {adminOnly: true, title: 'Resolve Plans'} },
  { path: 'resolve-plan', canActivate: [AuthGuard], data: {adminOnly: true},
    children: [
      { path: 'new', component: ResolvePlanNewComponent, canActivate: [AuthGuard], data: {adminOnly: true},
        canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: ResolvePlanEditComponent, canActivate: [AuthGuard], data: {adminOnly: true},
        canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'invoice-items', component: InvoiceItemComponent, canActivate: [AuthGuard], data: {adminOnly: true, title: 'Invoice Items'} },
  { path: 'invoices', component: InvoiceComponent, canActivate: [AuthGuard], data: {title: 'Invoices'} },
  { path: 'invoice/:id', component: InvoiceDetailComponent, canActivate: [AuthGuard] },
  { path: 'profiler', canActivate: [AuthGuard], data: {adminOnly: true},
    children: [
      { path: 'enable', component: ProfilerEnableComponent, canActivate: [AuthGuard], data: {adminOnly: true} },
      { path: 'disable', component: ProfilerDisableComponent, canActivate: [AuthGuard], data: {adminOnly: true} }
    ]
  },
  { path: 'performance-reports', canActivate: [AuthGuard], component: PerformanceReportComponent, data: {title: 'Performance Reports'} },
  { path: 'personal-info', canActivate: [AuthGuard], component: PersonalInfoComponent, data: {title: 'Personal Info'} },
  { path: 'path-performance-reports', canActivate: [AuthGuard], component: PathPerformanceReportComponent, data: {title: 'Path Performance Reports'} },
  { path: 'refund-reports-legacy', canActivate: [AuthGuard], component: RefundReportComponent, data: {title: 'Refund Reports'} },
  { path: 'refund-reports', canActivate: [AuthGuard], component: RefundReportV2Component, data: {title: 'Refund Reports'} },
  { path: 'chatbot-reports', canActivate: [AuthGuard], component: ChatbotReportV2Component, data: {title: 'Chatbot Reports'} },
  { path: 'refund-reports/:id', canActivate: [AuthGuard], component: RefundReportV2Component, data: {title: 'Refund Reports'} },
  { path: 'gateway-transaction-reports', canActivate: [AuthGuard], component: GatewayTransactionReportV2Component, data: {title: 'Gateway Transaction Reports'} },
  { path: 'gateway-dashboard', canActivate: [AuthGuard], component: GatewayDashboardComponent,
    data: {title: 'Gateway Dashboard', hideBackButton: true} },
  { path: 'gateway-performance-report-v3', canActivate: [AuthGuard], component: GatewayPerformanceReportV3Component, data: {title: 'Gateway Performance Report'} },
  { path: 'gateway-performance-report-v3/:id', canActivate: [AuthGuard], component: GatewayPerformanceReportV3Component, data: {title: 'Gateway Performance Report'} },
  { path: 'gateway-performance-report-v3/dim/:dimension', canActivate: [AuthGuard], component: GatewayPerformanceReportV3Component, data: {title: 'Gateway Performance Report'} },
  { path: 'order-options-report', canActivate: [AuthGuard], component: OrderOptionsReportComponent, data: {title: 'Order Options Report'} },
  { path: 'traffic-source-report', canActivate: [AuthGuard], component: TrafficSourceReportComponent, data: {title: 'Traffic Source Report'} },
  { path: 'customer-support-report', canActivate: [AuthGuard], component: CustomerSupportReportV3Component, data: {title: 'Customer Support Report'} },
  { path: 'customer-support-report/dim/:dimension', canActivate: [AuthGuard], component: CustomerSupportReportV3Component, data: {title: 'Customer Support Report'} },
  { path: 'customer-support-report/:id', canActivate: [AuthGuard], component: CustomerSupportReportV3Component, data: {title: 'Customer Support Report'} },
  {
    path: 'customer-journey-report/:journeyType/:journeyId',
    canActivate: [AuthGuard],
    component: CustomerJourneyReportV3Component,
    data: { title: 'Customer Journey Report' },
  },
  { path: 'single-step-report', canActivate: [AuthGuard], component: SingleStepReportComponent, data: {title: 'Single Step Report'} },
  { path: 'resolve-report', canActivate: [AuthGuard], component: ResolveReportV3Component,
    data: {title: 'Resolve Report', adminOnlyTag: '(AO Monitoring)'} },
  { path: 'resolve-report/dim/:dimension', canActivate: [AuthGuard], component: ResolveReportV3Component,
    data: {title: 'Resolve Report', adminOnlyTag: '(AO Monitoring)'} },
  { path: 'resolve-report/:id', canActivate: [AuthGuard], component: ResolveReportV3Component,
    data: {title: 'Resolve Report', adminOnlyTag: '(AO Monitoring)'} },
  { path: 'chargeback-report-legacy', canActivate: [AuthGuard], component: ChargebackReportComponent, data: {title: 'Chargeback Reports'} },
  { path: 'chargeback-reports', canActivate: [AuthGuard], component: ChargebackReportV2Component, data: {title: 'Chargeback Reports'} },
  { path: 'chargeback-reports/:id', canActivate: [AuthGuard], component: ChargebackReportV2Component, data: {title: 'Chargeback Reports'} },
  { path: 'sp-touched-reports', canActivate: [AuthGuard], component: SPTouchedChargebackReportV2Component, data: {title: 'SP Touched Reports'} },
  { path: 'sp-touched-reports/:id', canActivate: [AuthGuard], component: SPTouchedChargebackReportV2Component, data: {title: 'SP Touched Reports'} },
  { path: 'session-summary-reports', canActivate: [AuthGuard], component: SessionSummaryReportComponent, data: {title: 'Session Summary Reports'} },
  { path: 'marketplace-reports', canActivate: [AuthGuard], component: MarketplaceReportComponent, data: {title: 'Marketplace Reports'} },
  { path: 'retention-reports-legacy', canActivate: [AuthGuard], component: RetentionReportComponent, data: {title: 'Retention Reports'} },
  { path: 'subscription-retention-reports', canActivate: [AuthGuard], component: SubscriptionRetentionReportV2Component, data: {title: 'Subscription Retention Reports'} },
  { path: 'subscription-retention-reports/:id', canActivate: [AuthGuard], component: SubscriptionRetentionReportV2Component, data: {title: 'Subscription Retention Reports - (BETA)'} },
  { path: 'subscription-retention-report-v3', canActivate: [AuthGuard], component: SubscriptionRetentionReportV3Component, data: {title: 'Subscription Retention Report - (BETA)'} },
  { path: 'subscription-retention-report-v3/dim/:dimension', canActivate: [AuthGuard], component: SubscriptionRetentionReportV3Component, data: {title: 'Subscription Retention Report - (BETA)'} },
  { path: 'subscription-retention-report-v3/:id', canActivate: [AuthGuard], component: SubscriptionRetentionReportV3Component, data: {title: 'Subscription Retention Report'} },
  { path: 'order-retention-report-v3', canActivate: [AuthGuard], component: OrderRetentionReportV3Component, data: {title: 'Order Retention Report - (BETA)'} },
  { path: 'order-retention-report-v3/dim/:dimension', canActivate: [AuthGuard], component: OrderRetentionReportV3Component, data: {title: 'Order Retention Report - (BETA)'} },
  { path: 'order-retention-report-v3/:id', canActivate: [AuthGuard], component: OrderRetentionReportV3Component, data: {title: 'Order Retention Report - (BETA)'} },
  { path: 'return-retention-reports', canActivate: [AuthGuard], component: ReturnRetentionReportV2Component, data: {title: 'Return Retention Reports'} },
  { path: 'return-retention-reports/:id', canActivate: [AuthGuard], component: ReturnRetentionReportV2Component, data: {title: 'Return Retention Reports'} },
  { path: 'return-retention-report-v3', canActivate: [AuthGuard], component: ReturnRetentionReportV3Component, data: {title: 'Return Retention Report'} },
  { path: 'return-retention-report-v3/dim/:dimension', canActivate: [AuthGuard], component: ReturnRetentionReportV3Component, data: {title: 'Return Retention Report'} },
  { path: 'return-retention-report-v3/:id', canActivate: [AuthGuard], component: ReturnRetentionReportV3Component, data: {title: 'Return Retention Report'} },
  { path: 'new-order-retention-reports', canActivate: [AuthGuard], component: NewOrderRetentionReportV2Component, data: {title: 'New Order Retention Reports'} },
  { path: 'new-order-retention-reports/:id', canActivate: [AuthGuard], component: NewOrderRetentionReportV2Component, data: {title: 'New Order Retention Reports'} },
  { path: 'payment-updater-reports-legacy', canActivate: [AuthGuard], component: PaymentUpdaterReportComponent, data: {title: 'Payment Updater Reports'} },
  { path: 'payment-updater-reports', canActivate: [AuthGuard], component: PaymentUpdaterReportV2Component, data: {title: 'Payment Updater Reports'} },
  { path: 'payment-updater-reports/:id', canActivate: [AuthGuard], component: PaymentUpdaterReportV2Component, data: {title: 'Payment Updater Reports'} },
  { path: 'faq-lifeline-keywords/:id', component: AccountSearchKeywordsComponent, canActivate: [AuthGuard], data: {title: 'FAQ Lifeline Keywords'} },
  { path: 'exchangeable-products-set', canActivate: [AuthGuard], data: {adminOnly: false},
    children: [
      { path: '', component: ExchangeableProductsSetComponent, canActivate: [AuthGuard] },
      { path: 'new', component: ExchangeableProductsSetNewComponent, canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: ExchangeableProductsSetEditComponent, canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'exchangeable-category', canActivate: [AuthGuard], data: {adminOnly: false, title: 'Exchangeable Products Categories'},
    children: [
      { path: '', component: RelatedProductSetCategoryComponent, canActivate: [AuthGuard] },
      { path: 'new', component: RelatedProductSetCategoryNewComponent, canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: RelatedProductSetCategoryEditComponent, canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'exchangeable-set-type', canActivate: [AuthGuard], data: {adminOnly: false},
    children: [
      { path: 'new', component: RelatedProductSetNewComponent, canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: RelatedProductSetEditComponent, canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'reason-category', canActivate: [AuthGuard], data: {adminOnly: false, title: 'Reason Categories'},
    children: [
      { path: '', component: ReasonCategoryComponent, canActivate: [AuthGuard] },
      { path: 'new', component: ReasonCategoryNewComponent, canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: ReasonCategoryEditComponent, canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'folder', canActivate: [AuthGuard],
    children: [
      { path: 'new', component: FolderNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
      { path: 'edit/:id', component: FolderEditComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
    ]
  },
  { path: 'dev-env', canActivate: [AuthGuard], data: {adminOnly: true, title: 'Development Environments'},
    children: [
      { path: '', component: DevEnvComponent, canActivate: [AuthGuard], data: {adminOnly: true} },
      { path: 'new', component: DevEnvNewComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard], data: {adminOnly: true} },
    ]
  },
  { path: 'sso-complete', component: SSOCompleteComponent, canActivate: [AuthGuard] },
  { path: 'ticket-system', canActivate: [AuthGuard], data: {title: 'Ticket System'},
    children: [
      {path: '', component: TicketSystemComponent, canActivate: [AuthGuard]},
      {path: 'new', component: TicketSystemNewComponent, canActivate: [AuthGuard]},
      {path: 'edit/:id', component: TicketSystemEditComponent, canActivate: [AuthGuard]},
    ]
  },
  { path: 'shipping-system', canActivate: [AuthGuard], data: {title: 'Shipping System'},
    children: [
      {path: '', component: ShippingSystemComponent, canActivate: [AuthGuard]},
      {path: 'new', component: ShippingSystemNewComponent, canActivate: [AuthGuard]},
      {path: 'edit/:id', component: ShippingSystemEditComponent, canActivate: [AuthGuard]},
    ]
  },
  { path: 'audiences', canActivate: [AuthGuard], data: {title: 'Audiences'},
    children: [
      {path: '', component: AudienceComponent, canActivate: [AuthGuard]},
      {path: 'new', component: AudienceNewComponent, canActivate: [AuthGuard]},
      {path: 'edit/:id', component: AudienceEditComponent, canActivate: [AuthGuard]},
    ]
  },
  { path: 'new-paths', canActivate: [AuthGuard],
    children: [
      {path: '', component: PathComponent, canActivate: [AuthGuard]},
      {path: 'new', component: PathNewComponent, canActivate: [AuthGuard]},
      {path: 'edit/:id', component: PathEditComponent, canActivate: [AuthGuard]},
    ]
  },
  { path: 'customer-portals', canActivate: [AuthGuard, CampaignGuard], data: {title: 'Portals'},
    children: [
      {path: '', component: CustomerPortalEditComponent, canActivate: [AuthGuard, CampaignGuard]},
    ]
  },
  { path: 'email-integration', canActivate: [AuthGuard],
    children: [
      {path: ':campaign', canActivate: [AuthGuard],
        children: [
          {path: 'select', component: EmailIntegrationSelectComponent, canActivate: [AuthGuard]},
          // forwarding integration paths
          {path: 'forwarding', canActivate: [AuthGuard],
            children: [
              {path: 'new', component: EmailIntegrationForwardingNewComponent, canActivate: [AuthGuard]},
              {path: 'edit/:id', component: EmailIntegrationForwardingEditComponent, canActivate: [AuthGuard]}
            ]},
        ]
      },
      {path: 'gmail/auth/callback', component: GmailAuthCallbackComponent, canActivate: [AuthGuard]},
    ]
  },
  {
    path: 'mouseflow', canActivate: [AuthGuard], data: {title: 'Mouseflow'},
    children: [
      {path: 'toggle', component: MouseflowToggleComponent, canActivate: [AuthGuard]},
    ]
  },
  { path: 'merchant-profiles', canActivate: [AuthGuard], data: {title: 'Merchant Profiles'},
    children: [
      { path: '', component: MerchantProfilesComponent, canActivate: [AuthGuard] },
      { path: 'new', component: MerchantProfilesNewComponent, canActivate: [AuthGuard], data: {title: 'Merchant Profile'} },
      { path: 'edit/:id', component: MerchantProfilesEditComponent, canActivate: [AuthGuard], data: {title: 'Merchant Profile'} },
    ]
  },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes, { scrollPositionRestoration: "enabled" });
